import React from "react";
import { Box, Paper } from "@mui/material";
import { motion } from "framer-motion";
import TopBarOfMarketing from "../TopBarOfMarketing";
// eslint-disable-next-line no-unused-vars
import MarketingSplitBrandingPanel from "./MarketingSplitBrandingPanel";
import {
  marketingAuthCardSx,
  marketingAuthGradientSx,
  marketingPageShellSx,
} from "../../constants/marketingTokens";

const fadeUp = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
  viewport: { once: true, amount: 0.2 },
};

/**
 * Giriş / şifre sıfırlama — sol branding + sağ form kartı (440px).
 */
export default function MarketingAuthFormShell({
  darkMode,
  setDarkMode,
  children,
  maxWidth = 440,
}) {
  return (
    <Box sx={marketingPageShellSx}>
      <TopBarOfMarketing darkMode={darkMode} setDarkMode={setDarkMode} />

      <Box sx={marketingAuthGradientSx}>
        <motion.div {...fadeUp} style={{ width: "100%", maxWidth }}>
          <Paper elevation={0} sx={marketingAuthCardSx}>
            {children}
          </Paper>
        </motion.div>
      </Box>
    </Box>
  );
}
